<template>
  <Timeline>
    <TimelineItem v-for="item in logs" :key="item.id" >
      <p class="time">{{ moment(item.created_at).format('YYYY-MM-DD HH:mm:ss') }}</p>
      <p class="content"><b>操作内容：</b>{{ item.content }}</p>
      <p v-if="item.user"><b>操作用户：</b>{{ item.user.name ? item.user.name : item.user.username }}</p>
    </TimelineItem>
  </Timeline>
</template>
<script>
import { getJenkinsJobLogs } from '@/api/tools/jenkins'
import moment from 'moment'

export default {
  name: 'job-log',
  components: {
    moment
  },
  props: {
    jenkinsId: [Number, String],
    jobName: String
  },
  data () {
    return {
      logs: [],
      moment: moment
    }
  },
  watch: {
    jobName () {
      this.getLogs()
    }
  },
  created: function () {
    this.getLogs()
  },
  methods: {
    getLogs () {
      getJenkinsJobLogs(this.jenkinsId, this.jobName).then(res => {
        this.logs = res.data
      })
    }
  }
}
</script>
<style>
  .time{
    font-size: 14px;
    font-weight: bold;
  }
  .ivu-timeline-item-tail {
    /*border-left: 0 !important;*/
  }
  .content {
    word-wrap: break-word;
  }
</style>
